import React from "react";
import { Header, Image } from "semantic-ui-react";
import logo from "../../assets/images/urbansim/logo.png";
import RegisterAccountForm from "./RegisterAccountForm";

const RegisterAccount = ({
  onSubmit,
  onCancel,
  initialValues,
  userTypes,
  publicRoles,
  loading,
  showSuccessMessage,
  showFailureMessage,
  successMessageHeader,
  successMessageContent,
  failureMessageHeader,
  failureMessageContent
}) => {
  return (
    <>
      <Header as="h1" textAlign="center" style={{ paddingTop: "5%" }}>
        Create your UrbanSim account
        <Image
          size="small"
          src={logo}
          aria-label="Urbancanvas logo"
          style={{ marginBottom: "2%", marginLeft: "4%" }}
        />
      </Header>
      <RegisterAccountForm
        onCancel={onCancel}
        initialValues={initialValues}
        onSubmit={values => onSubmit(values)}
        userTypes={userTypes}
        publicRoles={publicRoles}
        loading={loading}
        showSuccessMessage={showSuccessMessage}
        showFailureMessage={showFailureMessage}
        successMessageHeader={successMessageHeader}
        successMessageContent={successMessageContent}
        failureMessageHeader={failureMessageHeader}
        failureMessageContent={failureMessageContent}
      />
    </>
  );
};

export default RegisterAccount;
